import { differenceInCalendarDays } from "date-fns";

export const useGetDayCount = (activeUntil: string): number => (
  differenceInCalendarDays(
    new Date(activeUntil),
    new Date()
  )
)